import Plot from 'react-plotly.js';

const LEGEND_POSITIONS = {
    'outside': { xanchor: 'left', yanchor: 'top' },
    'top-right': { x: 1, y: 1, xanchor: 'right', yanchor: 'top' },
    'bottom-right': { x: 1, y: 0.1, xanchor: 'right', yanchor: 'bottom' }
}

const TrainingReportLineChart = ({ data, name, legendPosition = 'outside', height = 300 }) => {
    const layout = {
        title: '',
        xaxis: {
            title: 'Epoch',
        },
        yaxis: {
            side: 'left'
        },
        showlegend: true,
        legend: LEGEND_POSITIONS[legendPosition] || LEGEND_POSITIONS['outside'],
        // run names carry their identifier at the end, so never truncate them in hover labels
        hoverlabel: { namelength: -1 },
        margin: {
            t: 5,
        },
        height,
        autosize: true
    }
    const config = { scrollZoom: false, displayModeBar: false, responsive: true, }

    return (
        <div className='m-1'>
            <div className="text-left text-lg text-gray-500 mx-5 my-3">{name}</div>
            <Plot
                data={data}
                layout={layout}
                config={config}
                style={{ width: "100%" }}
            />
        </div>
    )
}

export default TrainingReportLineChart